import { Card } from '@design-systems/canvas-ui'
import { useState } from 'react'
import { useSwipeToIndex } from '../../components/generalized-component/useSwipeToIndex'
import { useEssentials } from 'hooks/utils/useEssentials'
import { TRANSLATION_KEYS } from 'locales/translation-keys'

interface CardSliderProps {
    placements: {
        block: string
        aisle: string
        schematic_number: string
        section: string
        capacity: string
        is_home_location: boolean
    }[]
}

export const CardSlider: React.FC<CardSliderProps> = ({ placements }) => {
    const [currentIndex, setCurrentIndex] = useState(0)
    const { t } = useEssentials()
    const { itemSearch } = TRANSLATION_KEYS
    const { placementCapacityDescription } = itemSearch

    // Handle empty or invalid placements
    const safePlacements =
        placements && Array.isArray(placements) ? placements : []

    const { handleTouchStart, handleTouchMove, handleTouchEnd } =
        useSwipeToIndex({
            timePeriods: safePlacements.map((_: any, index: any) =>
                index.toString(),
            ),
            setTimePeriodIndex: setCurrentIndex,
        })

    if (safePlacements.length === 0) {
        return null
    }

    return (
        <div
            className="hc8-mt-3x hc8-mh-3x card-slider-container"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
        >
            {safePlacements.map((placement: any, index: number) => (
                <div
                    key={index}
                    // cannot be moved to scss file due to string literal template in transform
                    style={{
                        transform: `translateX(-${currentIndex * 100}%)`,
                    }}
                    className="card-slider"
                >
                    <Card className="hc8-mr-3x placements-card">
                        <span className="hc8-pt-3x hc8-fs-450">
                            <strong>
                                {placement.block}
                                {placement.aisle}
                            </strong>
                        </span>
                        <span>{placement.schematic_number}</span>
                        <span className="hc8-pt-2x hc8-pb-3x">
                            {placement.capacity}
                            {t(placementCapacityDescription)}
                        </span>
                    </Card>
                </div>
            ))}
        </div>
    )
}
